// @flow

import type { JSONValue } from 'common/types';
import { type Locale, locales } from 'common/types/locale';
import { oneOf } from 'common/json/extract';

export const locale: JSONValue => Locale = oneOf(locales);
